import { FC } from "react";
import Navbar from "./Navbar";
import Hero from "./Hero";
import ToolsSection from "./ToolsSection";
import FeaturesSection from "./FeaturesSection";
import TrustSection from "./TrustSection";
import CTABanner from "./CTABanner";
import Footer from "./Footer";

const Home: FC = () => {
    return (
        <div>
            <Navbar />
            <Hero />
            <div style={{ height: 1, background: "#f0ede8", margin: "0 40px" }} />
            <ToolsSection/>
            <div style={{ height: 1, background: "#f0ede8", margin: "0 40px" }} />
            <FeaturesSection />
            <div style={{ height: 1, background: "#f0ede8", margin: "0 40px" }} />
            <TrustSection />
            <CTABanner />
            <Footer />
        </div>
    );
};

export default Home;

